import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartOutlets } from '@spartacus/cart/base/root';
import { Order, OrderFacade, OrderHistoryFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { CustomCheckoutService } from '../../../../core/src/checkout/facade/custom-checkout.service';

@Component({
  selector: 'cx-order-confirmation-totals',
  templateUrl: './custom-order-confirmation-totals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomOrderConfirmationTotalsComponent implements OnInit, OnDestroy {
  readonly cartOutlets = CartOutlets;
  order$: Observable<Order | undefined>;
  displayOrderbyCode: boolean;

  constructor(
    protected orderFacade: OrderFacade,
    protected checkoutService: CustomCheckoutService,
    private activatedRoute: ActivatedRoute,
    private orderHistoryFacade: OrderHistoryFacade
  ) {
    this.displayOrderbyCode = !!this.activatedRoute.snapshot.url[1]?.path;
  }

  ngOnInit(): void {
    if (this.displayOrderbyCode) {
      this.order$ = this.orderHistoryFacade.getOrderDetails();
    } else {
      this.order$ = this.orderFacade.getOrderDetails();
    }
  }

  ngOnDestroy(): void {
    if (this.displayOrderbyCode) {
      this.orderHistoryFacade.clearOrderDetails();
    } else {
      this.orderFacade.clearPlacedOrder();
      ;
    }
  }
}
